import { render, staticRenderFns } from "./OrdiniRifiutati.vue?vue&type=template&id=61e8e8c8&"
import script from "./OrdiniRifiutati.vue?vue&type=script&lang=ts&"
export * from "./OrdiniRifiutati.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports